/**
 * FinopsHome — roteador de perfil + kill-switch da Home FinOps SP3.
 *
 * Decisões:
 *   1. Flag `finops_dashboard_v2_enabled` (§14):
 *        OFF → renderiza o dashboard LEGADO (`FinopsDashboard`) — kill-switch.
 *        ON  → monta a Home v2 (gestor ou admin).
 *   2. Perfil (§3.1/§5.6): `useFinopsScope` decide `<PlatformHome>` (admin:
 *        is_admin / admin:platform) vs `<ManagerHome>` (gestor escopado).
 *        NÃO usa `useScope` (domínio de chamados).
 *
 * O banner de "fonte de custo indisponível" (FINOPS_COST_FACTS_ENABLED OFF, §14)
 * é tratado dentro de `FinopsHomeBody`, usando o sinal `cost_available` das
 * respostas de `/my-portfolio` — o frontend não enxerga a flag SP2 diretamente.
 */
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { useFinopsScope } from '@/hooks/useFinopsScope'
import { FinopsDashboard } from './FinopsDashboard'
import { ManagerHome } from './ManagerHome'
import { PlatformHome } from './PlatformHome'

export function FinopsHome() {
  const { finops_dashboard_v2_enabled } = useFeatureFlags()
  const { isPlatformAdmin } = useFinopsScope()

  // Kill-switch: flag OFF cai no dashboard legado intacto (fallback).
  if (!finops_dashboard_v2_enabled) {
    return <FinopsDashboard />
  }

  return isPlatformAdmin ? <PlatformHome /> : <ManagerHome />
}
